import { cva } from 'class-variance-authority';

export const paginatedTableFrameVariants = cva(
  'hidden min-w-0 w-full am-lg:block overflow-x-auto px-4 pb-4 flex-col',
  {
    variants: {
      variant: {
        default: 'border-teal-300 bg-white',
        denim:
          'bg-denim-100 **:data-[slot=table-container]:bg-transparent **:data-[slot=table-cell]:bg-white [&_[data-slot=table-row]:hover_[data-slot=table-cell]]:bg-plum-100 [&_[data-slot=table-row][data-state=selected]_[data-slot=table-cell]]:bg-plum-100',
      },
      withoutBorder: {
        true: 'border-none bg-transparent **:data-[slot=table-container]:bg-transparent',
        false: 'rounded-3xl border',
      },
    },
    defaultVariants: {
      variant: 'default',
      withoutBorder: false,
    },
  }
);
